import type { ImageObject, WithContext } from 'schema-dts';

import { getObjectFromSearchParams } from '../../misc/url';

type GetModuleImageStructuredDataInput = {
	altText?: string | null;
	copyright?: string | null;
	caption?: string | null;
	url?: string | null;
};

export function buildModuleImageStructuredData({
	altText,
	copyright,
	caption,
	url,
}: GetModuleImageStructuredDataInput): WithContext<ImageObject> | null {
	if (!(!!altText || !!caption) || !copyright || !url) {
		return null;
	}

	const { h: height = 900, w: width = 1600 } = getObjectFromSearchParams(url);

	return {
		'@context': 'https://schema.org',
		'@type': 'ImageObject',
		caption: altText || caption || undefined,
		width: { '@type': 'QuantitativeValue', value: width, unitCode: 'px' },
		height: { '@type': 'QuantitativeValue', value: height, unitCode: 'px' },
		url,
		copyrightHolder: {
			'@type': 'Person',
			name: copyright,
		},
	};
}
